import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule,ColumnChooserService, PageService, SortService, FilterService, ResizeService  } from '@syncfusion/ej2-angular-grids';
import { MultiselectDropdownModule } from 'angular-2-dropdown-multiselect';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MaskedTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { BudgetimportComponent } from './budgetimport.component';
import { BudgetimportRoutingModule } from './budgetimport-routing.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { BudgetimportFormComponent } from './budgetimport-form/budgetimport-form.component';
import { BudgetplanFormModule } from '../budgetplan-form/budgetplan-form.module';
import { MyDatePickerModule } from 'mydatepicker';
import { budgetlistService } from './budgetimportdata.service';

@NgModule({
  declarations: [
    BudgetimportComponent,
    BudgetimportFormComponent
  ],
  imports: [
    MyDatePickerModule,
    BudgetimportRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MultiselectDropdownModule,
    GridModule,
    NgxUiLoaderModule,
    MaskedTextBoxModule,
    NgSelectModule,
    BudgetplanFormModule
  ],
  exports:[BudgetimportComponent,BudgetimportFormComponent],
  providers: [ColumnChooserService,PageService,SortService,FilterService,ResizeService,budgetlistService ],
})
export class BudgetimportModule { }
